var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_firstname" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.firstName")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.firstName,
            expression: "contact.firstName"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_firstname", type: "text" },
        domProps: { value: _vm.contact.firstName },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "firstName", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_lastname" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.lastName")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.lastName,
            expression: "contact.lastName"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_lastname", type: "text" },
        domProps: { value: _vm.contact.lastName },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "lastName", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("label", { attrs: { for: _vm.uid + "_salutation" } }, [
          _vm._v(_vm._s(_vm.$t("common.contacts.model.salutation")))
        ]),
        _vm._v(" "),
        _c("vSelect", {
          attrs: {
            id: _vm.uid + "_salutation",
            options: _vm.availableSalutations,
            taggable: true
          },
          model: {
            value: _vm.contact.salutation,
            callback: function($$v) {
              _vm.$set(_vm.contact, "salutation", $$v)
            },
            expression: "contact.salutation"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_company" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.company")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.company,
            expression: "contact.company"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_company", type: "text" },
        domProps: { value: _vm.contact.company },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "company", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_email" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.email")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.email,
            expression: "contact.email"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_email", type: "text" },
        domProps: { value: _vm.contact.email },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "email", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_tel" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.tel")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.tel,
            expression: "contact.tel"
          }
        ],
        staticClass: "form-control",
        class: {
          "is-invalid": _vm.contact.tel && !_vm.isValidPhone(_vm.contact.tel)
        },
        attrs: {
          id: _vm.uid + "_tel",
          type: "tel",
          placeholder: _vm.phonePlaceholder
        },
        domProps: { value: _vm.contact.tel },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "tel", $event.target.value)
          }
        }
      }),
      _vm._v(" "),
      _vm.contact.tel && !_vm.isValidPhone(_vm.contact.tel)
        ? _c("small", { staticClass: "text-danger" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("common.contacts.invalidPhoneNumber")) +
                "\n    "
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }